export default __webpack_public_path__ + "static/media/640_business05-jp-web.4d1904dd.png";